import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, exhaustMap, map, of, tap } from 'rxjs';

import { ContabilidadeService } from 'src/app/shared/services/contabilidade.service';
import {
  deleteContabilidade,
  editContabilidade,
  loadContabilidade,
  loadContabilidadeSuccess,
  saveContabilidade,
} from './contabilidade.actions';
import { NotifyService } from 'src/app/shared/services/notify.service';

@Injectable()
export class ContabilidadeEffects {
  constructor(
    private service: ContabilidadeService,
    private notify: NotifyService,
    private action$: Actions
  ) {}

  loadContabilidade$ = createEffect(() =>
    this.action$.pipe(
      ofType(loadContabilidade),
      exhaustMap(() =>
        this.service
          .getAll()
          .pipe(
            map((res) => loadContabilidadeSuccess({ lista: res })),
            catchError((error) => {
              this.notify.emitError('Falha ao carregar registros')
              return of(error.error['hydra:description'])
          })
          )
      )
    )
  );

  saveContabilidade$ = createEffect(() =>
    this.action$.pipe(
      ofType(saveContabilidade),
      concatMap(({ contabilidade }) =>
        this.service.save(contabilidade).pipe(
          tap(() => this.notify.saveSuccess()),
          map((res) => loadContabilidade()),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description']);
            //console.log(error);
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );

  editContabilidade$ = createEffect(() =>
    this.action$.pipe(
      ofType(editContabilidade),
      concatMap(({ contabilidade, id }) =>
        this.service.edit(contabilidade, id).pipe(
          tap(() => this.notify.editSuccess()),
          map((res) => loadContabilidade()),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            //console.log(error);
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );

  deleteContabilidade$ = createEffect(() =>
    this.action$.pipe(
      ofType(deleteContabilidade),
      concatMap(({ id }) =>
        this.service.delete(id).pipe(
          tap(() => this.notify.deleteSuccess()),
          map((res) => loadContabilidade()),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            //console.log(error);
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );
}
